import React from 'react';
import { Link } from 'react-router-dom';
import { useCountry } from './CountryContext';
import { useCookieConsent } from './CookieContext';

function Footer() {
  const { selectedCountry, updateCountry } = useCountry();
  const { setShowBanner } = useCookieConsent();

  const countries = [
    { code: 'IT', name: 'Italia' },
    { code: 'DE', name: 'Germania' },
    { code: 'FR', name: 'Francia' },
    { code: 'ES', name: 'Spagna' },
    { code: 'GB', name: 'Regno Unito' },
    { code: 'US', name: 'Stati Uniti' },
    { code: 'CA', name: 'Canada' },
    { code: 'AU', name: 'Australia' },
    { code: 'JP', name: 'Giappone' },
    { code: 'CN', name: 'Cina' }
  ];

  const handleCountryChange = (e) => {
    updateCountry(e.target.value);
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          
          {/* Colonna 1: Menu per Clienti */}
          <div className="footer-column">
            <h5 className="footer-title">Scopri</h5>
            <ul className="footer-menu">
              <li><Link to="/come-funziona">Come Funziona</Link></li>
              <li><Link to="/categories">Categorie</Link></li>
              <li><Link to="/brands">Brand</Link></li>
              <li><Link to="/contatti">Contatti</Link></li>
            </ul>
          </div>

          {/* Colonna 2: Menu per Venditori */}
          <div className="footer-column">
            <h5 className="footer-title">Business</h5>
            <ul className="footer-menu">
              <li><Link to="/diventa-inserzionista">Per i siti e-commerce</Link></li>
              <li><Link to="/sign-up-seller">Registrazione Venditori</Link></li>
              <li><Link to="/login">Accesso Venditori</Link></li>
            </ul>
          </div>

          {/* Colonna 3: Newsletter e info sito */}
          <div className="footer-column footer-newsletter">
            <h5 className="footer-title">Contattaci</h5>
            <p className="footer-description"><a href='mailto:info@loverlist.it'>info@loverlist.it</a></p>
            <h5 className="footer-title">Iscriviti alla Newsletter</h5>
            <p className="footer-description">Rimani aggiornato su nuove offerte e sconti.</p>
            <div className="newsletter-form">
              <input 
                type="email" 
                className="newsletter-input" 
                placeholder="Inserisci la tua email" 
              />
              <button className="newsletter-btn" type="button">Iscriviti</button>
            </div>
            
            <div className="footer-country-selector">
              <label htmlFor="country-select" className="footer-country-label">
                Paese di spedizione:
              </label>
              <select
                id="country-select"
                className="footer-country-select"
                value={selectedCountry}
                onChange={handleCountryChange}
              >
                {countries.map(country => (
                  <option key={country.code} value={country.code}>
                    {country.name}
                  </option>
                ))}
              </select>
            </div>
            
            <p className="footer-info">
              Loverlist è un comparatore di prezzi.
            </p>
          </div>

        </div>

        <div className="footer-divider"></div>

        {/* Sezione "I siti del gruppo" */}
        <div className="group-sites-section">
          <h3 className="group-sites-title">I siti del gruppo</h3>
          <div className="group-sites-grid">
            <div className="group-sites-item">
              <a href="https://commerciovirtuoso.it" target="_blank" className="group-sites-link">
                <div className="group-sites-logo-container">
                  <img src="/logo_commerciovirtuoso_black.png" alt="commercioVirtuoso.it Logo" className="group-sites-logo" />
                </div>
                <p className="group-sites-description">commercioVirtuoso.it è il Marketplace dei migliori negozi italiani</p>
              </a>
            </div>
            <div className="group-sites-item">
              <a href="https://maptap.it" target="_blank" className="group-sites-link">
                <div className="group-sites-logo-container">
                  <img src="/logo_maptap_black.png" alt="MapTap.it Logo" className="group-sites-logo" />
                </div>
                <p className="group-sites-description">MapTap.it è la Directory di aziende professionisti e attività commerciali.</p>
              </a>
            </div>
            <div className="group-sites-item">
              <a href="https://loverlist.com" target="_blank" className="group-sites-link">
                <div className="group-sites-logo-container">
                  <img src="/logo_loverlist_black.png" alt="Loverlist.com Logo" className="group-sites-logo" />
                </div>
                <p className="group-sites-description">Loverlist.com è il comparatore di prezzo CSS certificato Google</p>
              </a>
            </div>
            <div className="group-sites-item">
              <a href="https://trackingposte.it" target="_blank" className="group-sites-link">
                <div className="group-sites-logo-container">
                  <img src="/logo_trackingposte_black.png" alt="TrackingPoste.it Logo" className="group-sites-logo" />
                </div>
                <p className="group-sites-description">TrackingPoste.it è il sito per tracciare qualsiasi spedizione</p>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-divider"></div>

        {/* Blocco finale con info sull'azienda */}
        <div className="footer-bottom">
          <div className="footer-bottom-left">
            <p className="footer-copyright">
              © 2026 Loverlist.com Tutti i diritti riservati | <a href="https://malianta.com" target="_blank" rel="noopener noreferrer">Malianta srl</a> P.IVA 10412320961 | via Terraglio 30174 Venezia (VE) 
            </p>
          </div>
          <div className="footer-bottom-right">
            <ul className="footer-legal-links">
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service">Termini di Servizio</Link></li>
              <li><button 
                className="footer-cookie-link" 
                onClick={() => setShowBanner(true)}
              >
                Gestione Cookie
              </button></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

